import { Row, Col, ButtonText, Typography, List } from "@visa/vds"
import MCSGridRevert from "components/MCSGridRevert"
import React, { useEffect, useState } from "react"
import GettingStartedQuestionnaire from "./Components/GettingStartedQuestionnaire";
import illustrationOne from "_imgs/gettingStarted/getting-started-illustration-1.png"
import { trackPromise } from "react-promise-tracker";
import { gettingStartedService } from "services/certification.gettingStarted";
import MCSOverlayLoading from "components/MCSOverlayLoading";
import { LibraryPostType } from "_constants/LibraryConstants";
import { LibraryPostFileClickAction } from "_constants/GlobalConstants";
import { LibraryHelper } from "_helpers/LibraryHelper";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { PUBLIC_OVERVIEW } from "_constants/PageRoutes";
import "./GettingStartedPage.css"


const GettingStartedPage = () => {

    const history = useHistory();
    const [dialog, setDialog] = useState(false);
    const [links, setLinks] = useState(null)

    const fetchLinks = () => {
        trackPromise(gettingStartedService.GetGettingStartedLibraryPosts()
            .then((result) => {
                setLinks(result.data.result)
            }))
    }

    let handleLibraryObject = (postId) => {
        LibraryHelper.handleLibraryPostOnClick({
            postId,
            postType: LibraryPostType.File,
            action:
                LibraryPostFileClickAction.Open
        })
    }

    useEffect(() => {
        fetchLinks()
    }, [])

    return (
        <>
            {dialog && <GettingStartedQuestionnaire setDialog={setDialog} />}
            <MCSGridRevert>

                <Row>
                    <Col>
                        <Typography tag="h1" variant="headline" className="color-navy">Getting Started with Visa Secure</Typography>
                        <Typography variant="body" className="vss-text-body-large">
                            This Getting Started page provides an overview for Product Providers of EMV 3DS software of the process to onboard EMV 3DS Access Control Servers (ACS) and 3DS Server (3DSS) products with Visa Secure.
                            Visa Secure is Visa’s program that supports EMV 3DS authentication. Go to the <span onClick={() => history.push(PUBLIC_OVERVIEW)} id="getting-started-visa-secure-overview-link" className="getting-started-link-text">Visa Secure Overview page</span> to learn more about Visa Secure.</Typography>
                    </Col>
                </Row>

                <Row className="display-flex justify-content-space-between">
                    <Col xs={4} sm={8} md={4} lg={5} xl={5}>
                        <Typography className="benefit-title">Visa Secure Requirements</Typography>
                        <Typography variant="body" className="vss-text-body-large">
                            {"Visa Secure requirements apply to companies who are developing, operating, or selling EMV 3DS software that will connect with the Visa Secure DS. The requirements can be found in the Certification Guides at the bottom of the page or by completing the Implementation Type Questionnaire and reviewing the Results page."}
                            <br /><br />
                            {"To connect your EMVCo certified 3DS software to a Visa Directory Server (DS), you must show that your software's EMVCo 3DS certification is current, and both Visa and applicable payment industry requirements are met."}
                        </Typography>
                    </Col>
                    <div className="separator"></div>
                    <Col xs={4} sm={8} md={4} lg={5} xl={5}>
                        <Typography className="benefit-title">Implementation Types</Typography>
                        <Typography variant="body" className="vss-text-body-large">
                            You need to know your implementation type to begin. The different ways that a Visa Secure client can connect to Visa Secure and the Visa Secure DS are defined as “implementation types”. Knowing your specific Visa Secure implementation type(s) will help simplify your first-time certification or repeat certification process.
                        </Typography>
                    </Col>
                </Row>

                <Row className="display-flex justify-content-space-between">
                    <Col xs={4} sm={8} md={4} lg={6} xl={6} className="display-flex justify-content-center">
                        <Typography tag="h1" variant="headline" className="visa-blue">Implementation Type Questionnaire</Typography>
                        <Typography variant="body" className="vss-text-body-large">Click the button below to review and complete the questions to determine which implementation type(s) apply and the corresponding requirements that must be met as part of the Visa’s EMV 3DS Certification process. Once collected, email all required materials to <a href="mailto:gctv3dsts@visa.com"><span className="getting-started-link-text">gctv3dsts@visa.com</span></a> and be sure to indicate the BID and all implementation types applicable to the solution.</Typography>
                        <ButtonText
                            onClick={() => setDialog(true)}
                            className="width-full getting-started-button-text margin-left-0px border-radius-20px" id="getting-started-identify-implementation-button">Identify Your Implementation Type
                        </ButtonText>
                    </Col>
                    <Col xs={4} sm={8} md={4} lg={6} xl={6} style={{ display: "flex", justifyContent: "center" }}>
                        <img className="width-full" src={illustrationOne} alt={"illustration-1"} />
                    </Col>
                </Row >
                <Row>
                    <Col className="getting-started-for-more-information">
                        <Typography tag="h1" variant="headline" className="visa-blue">For More Information</Typography>

                        <List>
                            <li>
                                <Typography onClick={() => handleLibraryObject(links.acsAnd3dssCertificationGuidePostId)} className="getting-started-link-text" id="getting-started-link-acs-guide">Visa Product Provider Certification Guide: ACS and 3DSS </Typography>
                            </li>
                            <li>
                                <Typography onClick={() => handleLibraryObject(links.vstsAndFaqPostId)} className="getting-started-link-text" id="getting-started-link-vsts-testing-faq">Access to Visa Secure Test Suite and Testing FAQs</Typography>
                            </li>
                            <li>
                                <a className="text-decoration-none" href="https://www.emvco.com/processes/emv-3-d-secure-approval-processes/" target="_blank" rel="noopener noreferrer">
                                    <Typography id="getting-started-link-approval-process" className="getting-started-link-text" >EMVCo EMV 3DS Approval Process</Typography>
                                </a>
                            </li>
                            <li>
                                <a className="text-decoration-none" href="https://www.pcisecuritystandards.org/document_library/?category=3DS&document=3DS_standard" target="_blank" rel="noopener noreferrer">
                                    <Typography className="getting-started-link-text" id="getting-started-link-pci-security-standards">PCI Security Standards</Typography>
                                </a>
                            </li>
                        </List>
                    </Col>
                </Row>
            </MCSGridRevert >
        </>
    )
}

export default GettingStartedPage